import { useMutation } from '@tanstack/react-query';
import { PatientDocument } from 'src/models';
import { ambientApi } from 'src/services';

export type UpdatePatientDocumentPayload = {
  patientDocumentId: PatientDocument['patient_document_id'];
} & Partial<PatientDocument>;

export const useUpdatePatientDocument = () => {
  return useMutation({
    mutationFn: ({
      patientDocumentId,
      ...payload
    }: UpdatePatientDocumentPayload) => {
      return ambientApi
        .put(`/patient_document/${patientDocumentId}`, payload)
        .then(({ data }) => data);
    },
  });
};
